// Logo
// ====

import React from 'react'
import LogoWithoutLink, { LogoType } from '../logo-without-link'

interface LogoProps {
  url?: string
  className?: string
  linkClassName?: string
  type?: LogoType
}

const Logo: React.FunctionComponent<LogoProps> = ({
  url,
  className,
  linkClassName,
  type = 'default',
}) => {
  if (url) {
    return (
      <a className={linkClassName} href={url}>
        <LogoWithoutLink className={className} type={type} />
      </a>
    )
  } else {
    return <LogoWithoutLink className={className} type={type} />
  }
}

export default Logo
